export default __webpack_public_path__ + "static/enterprise-landing-87dcf5b280573c90f35f33df456776a8.png";